import { render, staticRenderFns } from "./ClubClubhouse.vue?vue&type=template&id=800b3b8a"
import script from "./ClubClubhouse.vue?vue&type=script&lang=js"
export * from "./ClubClubhouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports